import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import iframeServer from '@/views/iframe-server/index';
export default {
  name: 'CardTopicDialog',
  components: {
    iframeServer: iframeServer
  },
  props: {
    showDialog: {
      type: Boolean
    },
    reviewCardUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: this.showDialog,
      iframeUrl: this.reviewCardUrl
    };
  },
  created: function created() {
    this.$bus.$on('closeReviewDialog', this.handleClose);
  },
  destroyed: function destroyed() {
    this.$bus.$off('closeReviewDialog');
  },
  methods: {
    handleClose: function handleClose() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('queryTaskInfo', 1, 'update'); // 刷新复习首页的卡片列表第一页


                _this.$emit('update:showDialog', false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};